module.exports = __webpack_public_path__ + "img/male.58792755.png";